import { Directive, Input, OnChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BuyingPowerDetails, Position } from '@zero/shared/util-models';
import { OrderFormGroup } from '@zero/trade/domain';

@Directive()
export class TradeCreateVolumeBaseComponent implements OnChanges {
  @Input() public form?: FormGroup<OrderFormGroup>;
  @Input() public orderVolume?: number;
  @Input() public buyingPower?: number;
  @Input() public buyingPowerDetails?: BuyingPowerDetails;
  @Input() public positionInSelectedAsset?: Position;

  public isBuyingPowerTooLow = false;
  public isBuy = false;
  public hasFraction = false;

  public ngOnChanges(): void {
    this.isBuy = this.form?.get('direction')?.value === 'buy';
    this.isBuyingPowerTooLow = this.isBuy && this.orderVolume > this.buyingPower;
    if (this.isBuyingPowerTooLow) {
      this.form.get('orderValue').setErrors({
        bpTooLow: true,
      });
    } else {
      this.form.patchValue({
        orderValue: this.orderVolume,
      });
    }
    this.hasFraction = Number(this.positionInSelectedAsset?.availableQuantity) && this.positionInSelectedAsset.availableQuantity % 1 > 0;
  }
}
